module.exports = __webpack_public_path__ + "static/img/17.fa8e19a2.png";